<template>
  <div class="page"> 
    <div class="feature-list" v-show="currentRef !== undefined" :style="featureListStyle" ref="featureList">
        <div class="gallery" v-if="currentRef !== undefined && locations[openLocation].images !== undefined && locations[openLocation].images.length > 0">
            <div class="images">
                <vueper-slides ref="vueper" class="images" :arrows="true" :bullets="false" :dragging-distance="70">
                    <vueper-slide 
                        v-for="(image, id) in locations[openLocation].images" 
                        :key="id" class='image' 
                        :image="image"                                
                    />
                    <template v-slot:arrow-left>
                        <RoundIcon flip small icon="icon_arrow-gallery.svg" />
                    </template>

                    <template v-slot:arrow-right>
                        <RoundIcon small icon="icon_arrow-gallery.svg" />
                    </template>
                </vueper-slides>
                <ShowImage :showImage="showImage" small gradient @click="showImage = true;"/>
            </div>
        </div>
        <p class="name"><span class="yellow">{{locations[openLocation].name}}</span></p>
        <p class="feature" v-for="(feature, id) in locations[openLocation].features" :key="id">{{feature}}</p>
    </div>  
    <svg width="1104px" height="850px" viewBox="0 0 1104 850" preserveAspectRatio="xMidYMid meet" @click.stop="resetActive();">
        <defs>
            <linearGradient x1="-8.37034404e-17%" y1="0.376966783%" x2="-2.21334945e-14%" y2="99.6803977%" id="linearGradient-1">
                <stop stop-color="#4A4A4A" offset="0%"></stop>
                <stop stop-color="#111111" offset="100%"></stop>
            </linearGradient>
            <linearGradient x1="100%" y1="50%" x2="-2.22044605e-14%" y2="50%" id="linearGradient-4">
                <stop stop-color="#F5831F" offset="0%"></stop>
                <stop stop-color="#FED208" offset="100%"></stop>
            </linearGradient>
            <circle id="path-2" cx="22.5" cy="22.5" r="22.5"></circle>
            <filter x="-77.8%" y="-55.6%" width="255.6%" height="255.6%" filterUnits="objectBoundingBox" id="filter-3">
                <feOffset dx="0" dy="10" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="10" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
            </filter>
            
            <filter x="-77.8%" y="-55.6%" width="255.6%" height="255.6%" filterUnits="objectBoundingBox" id="filter-6">
                <feOffset dx="0" dy="10" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="10" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
            </filter>            
        </defs>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="[EVENT-PRODUCTION]-Back-Stage-Map" transform="translate(-180.000000, 0.000000)">
                <g id="BACKSTAGE-MAP-PLUS-BUTTONS" transform="translate(180.000000, 0.000000)">
                    <rect id="Mask" x="0" y="0" width="1104" height="850"></rect>                                                                                                                             
                    <g class='location' ref='loc0' @click.stop="setActive(0, 'loc0');" id="PLUS-VISITORS-LOCKER-ROOM" transform="translate(316.000000, 215.000000)">
                        <g id="Oval" fill-rule="nonzero">
                            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-2"></use>
                            <use fill="url(#linearGradient-1)" xlink:href="#path-2"></use>
                        </g>
                        <g id="Group" transform="translate(17.000000, 17.000000)" fill="url(#linearGradient-4)">
                            <g id="Icon/Close" transform="translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) ">
                                <polygon points="9.88487973 11 11 9.88487973 6.61512027 5.5 11 1.11512027 9.88487973 0 5.5 4.38487973 1.11512027 0 0 1.11512027 4.38487973 5.5 0 9.88487973 1.11512027 11 5.5 6.61512027"></polygon>
                            </g>
                        </g>
                    </g>
                    <g class='location' ref='loc1' @click.stop.stop="setActive(1, 'loc1');" id="PLUS-UNLV-LOCKER-ROOM" transform="translate(410.000000, 514.000000)">
                        <g id="Oval" fill-rule="nonzero">
                            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-2"></use>
                            <use fill="url(#linearGradient-1)" xlink:href="#path-2"></use>
                        </g>
                        <g id="Group" transform="translate(17.000000, 17.000000)" fill="url(#linearGradient-4)">
                            <g id="Icon/Close" transform="translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) ">
                                <polygon points="9.88487973 11 11 9.88487973 6.61512027 5.5 11 1.11512027 9.88487973 0 5.5 4.38487973 1.11512027 0 0 1.11512027 4.38487973 5.5 0 9.88487973 1.11512027 11 5.5 6.61512027"></polygon>
                            </g>
                        </g>
                    </g>
                    <g class='location' ref='loc2' @click.stop.stop="setActive(2, 'loc2');" id="PLUS-RAIDERETTES" transform="translate(316.000000, 491.000000)">
                        <g id="Oval" fill-rule="nonzero">
                            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-2"></use>
                            <use fill="url(#linearGradient-1)" xlink:href="#path-2"></use>
                        </g>
                        <g id="Group" transform="translate(17.000000, 17.000000)" fill="url(#linearGradient-4)">
                            <g id="Icon/Close" transform="translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) ">
                                <polygon points="9.88487973 11 11 9.88487973 6.61512027 5.5 11 1.11512027 9.88487973 0 5.5 4.38487973 1.11512027 0 0 1.11512027 4.38487973 5.5 0 9.88487973 1.11512027 11 5.5 6.61512027"></polygon>
                            </g>
                        </g>
                    </g>                       
                    <g class='location' ref='loc4' @click.stop.stop="setActive(3, 'loc4');" id="PLUS-OFFICIALS-LOCKER-ROOM" transform="translate(672.000000, 239.000000)">
                        <g id="Oval" fill-rule="nonzero">
                            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-2"></use>
                            <use fill="url(#linearGradient-1)" xlink:href="#path-2"></use>
                        </g>
                        <g id="Group" transform="translate(17.000000, 17.000000)" fill="url(#linearGradient-4)">
                            <g id="Icon/Close" transform="translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) ">
                                <polygon points="9.88487973 11 11 9.88487973 6.61512027 5.5 11 1.11512027 9.88487973 0 5.5 4.38487973 1.11512027 0 0 1.11512027 4.38487973 5.5 0 9.88487973 1.11512027 11 5.5 6.61512027"></polygon>
                            </g>
                        </g>
                    </g>          
                    <g class='location' ref='loc5' @click.stop.stop="setActive(4, 'loc5');" id="PLUS-POST-GAME-INTERVIEW" transform="translate(526.000000, 547.000000)">
                        <g id="Oval" fill-rule="nonzero">
                            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-2"></use>
                            <use fill="url(#linearGradient-1)" xlink:href="#path-2"></use>
                        </g>
                        <g id="Group" transform="translate(17.000000, 17.000000)" fill="url(#linearGradient-4)">
                            <g id="Icon/Close" transform="translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) ">
                                <polygon points="9.88487973 11 11 9.88487973 6.61512027 5.5 11 1.11512027 9.88487973 0 5.5 4.38487973 1.11512027 0 0 1.11512027 4.38487973 5.5 0 9.88487973 1.11512027 11 5.5 6.61512027"></polygon>
                            </g>
                        </g>
                    </g>  
                    <g class='location' ref='loc6' @click.stop.stop="setActive(5, 'loc6');" id="PLUS-MEDIA-COMPOUND" transform="translate(820.000000, 438.000000)">
                        <g id="Oval" fill-rule="nonzero">
                            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-2"></use>
                            <use fill="url(#linearGradient-1)" xlink:href="#path-2"></use>
                        </g>
                        <g id="Group" transform="translate(17.000000, 17.000000)" fill="url(#linearGradient-4)">
                            <g id="Icon/Close" transform="translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) ">
                                <polygon points="9.88487973 11 11 9.88487973 6.61512027 5.5 11 1.11512027 9.88487973 0 5.5 4.38487973 1.11512027 0 0 1.11512027 4.38487973 5.5 0 9.88487973 1.11512027 11 5.5 6.61512027"></polygon>
                            </g>
                        </g>
                    </g>
                    <g class='location' ref='loc7' @click.stop.stop="setActive(6, 'loc7');" id="PLUS-BREAK-ROOM" transform="translate(914.000000, 545.000000)">
                        <g id="Oval" fill-rule="nonzero">
                            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-2"></use>
                            <use fill="url(#linearGradient-1)" xlink:href="#path-2"></use>
                        </g>
                        <g id="Group" transform="translate(17.000000, 17.000000)" fill="url(#linearGradient-4)">
                            <g id="Icon/Close" transform="translate(5.500000, 5.500000) rotate(45.000000) translate(-5.500000, -5.500000) ">
                                <polygon points="9.88487973 11 11 9.88487973 6.61512027 5.5 11 1.11512027 9.88487973 0 5.5 4.38487973 1.11512027 0 0 1.11512027 4.38487973 5.5 0 9.88487973 1.11512027 11 5.5 6.61512027"></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg> 
    <p class="note">*All backstage spaces are subject to availability based on seasonality and are determined on a show by show basis.</p>
    <div class="fullscreen-images" v-if="showImage">
        <vueper-slides ref="vueper" class="images" :arrows="false" :bullets="false" :dragging-distance="70">
            <vueper-slide 
                v-for="(image, id) in locations[openLocation].images" 
                :key="id" class='image' 
                :image="image"                                
            />            
        </vueper-slides>
        <ShowImage :showImage="showImage" gradient @click="showImage = false;"/>
    </div>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import ShowImage from "@/patterns/ShowImage.vue";
import RoundIcon from "@/patterns/RoundIcon.vue";
export default {
    name: "BackstageMap",
    components: { VueperSlides, VueperSlide, ShowImage, RoundIcon } ,
    /*
    ,
                images : [
                    require('@/assets/images/event_production/BACKSTAGE-MAP-IMAGE.jpg'),
                    require('@/assets/images/event_production/BACKSTAGE-MAP-IMAGE.jpg'),
                ]
    */
    data: () => ({
        openLocation:0,   
        currentRef:undefined,     
        showImage:false,
        locations:[
            {
                name:'Visitors Locker Room',
                controlPosition:'Right',
                features : [
                    '12,000 square feet',
                    '1 large locker room with the capability to divide into 2 large mirrored spaces with airwall',
                    '6 supporting rooms/offices',
                    '6 bathrooms'
                ]
            },
            {
                name:'UNLV Locker Room',
                controlPosition:'Top',
                features : [
                    '10,000 square feet',
                    '1 large locker room with the capability to divide into 2 large mirrored spaces with airwall',
                    '6 supporting rooms/offices',
                    '6 bathrooms'
                ]
            },
            {
                name:'Raiderettes Locker Room',
                controlPosition:'Top',
                features : [
                    '1,500 square feet',
                    '1 bathroom '
                ]
            },
            /*
            {
                name:'Raiders Family Room',
                controlPosition:'Top',
                features: [
                    '3,000 square feet',
                    '2 large open layout areas with shared kitchen/serving area',
                    '1 supporting room',
                    '3 bathrooms',

                ]
            },
            */
            {
                name:'Officials Locker Room',
                controlPosition:'Left',
                features: [
                    '3,000 square feet',
                    '3 locker rooms',
                    '2 supporting rooms',
                    '4 bathrooms',
                ]
            },
            {
                name:'Post-Game Interview Room',
                controlPosition:'Top',
                features:[
                    '2,000 square feet'
                ]
            },
            {
                name:'Media Compound',
                controlPosition:'Left',
                features: [
                    '2,100 square feet',
                    '4 rooms/offices'
                ]
            },
            {
                name:'Break Room',
                controlPosition:'Right',
                features:[
                    '2,300 square feet',
                    '2 bathrooms'
                ]
            }
        ],
        featureListStyle : {
            top:'0px;',
            left:'0px;',
        }
    }),
    mounted() {        
        window.addEventListener("resize", this.setPosition);
    },
    updated: function() {
        window.addEventListener("resize", this.setPosition);
    },    
    beforeDestroy: function () {
        window.removeEventListener("resize", this.setPosition);
    },
    methods : {
        setPosition() {
            if(this.currentRef === undefined) {
                return
            }
            const element = this.$refs[this.currentRef];
            const features = this.$refs['featureList'];
            const featuresRect = features.getBoundingClientRect();            
            const boundingRect = element.getBoundingClientRect();            
            this.featureListStyle = {
                left:`${boundingRect.left - 190 + boundingRect.width + 25}px`,
                top:`${boundingRect.top}px`,
            }
            const controlPosition = this.locations[this.openLocation].controlPosition;
            if(controlPosition == 'Right') {
                this.featureListStyle = {
                    left:`${boundingRect.left - 190 + boundingRect.width - 25  - 15 - 290}px`,
                    top:`${boundingRect.top}px`,
                }
            } else if(controlPosition == 'Top') {
                this.featureListStyle = {
                    left:`${boundingRect.left - 190 + 10}px`,
                    top:`${boundingRect.top - boundingRect.height - featuresRect.height + 20}px`,
                }
            }
        },
        resetActive() {
            this.openLocation = 0;
            this.currentRef = undefined;
        },
        setActive(position, ref) {
            if(this.openLocation === position && this.currentRef !== undefined) {
                this.openLocation = 0;
                this.currentRef = undefined;
                return;
            }
            this.openLocation = position;
            this.currentRef = ref;  
            this.$nextTick(() => {
                this.setPosition();
            });
            
        }
    }
};
</script>
<style lang="scss">
    .fullscreen-images {
        .images {
            height:100%;
        }
        .vueperslides__inner {
            height:inherit;
        }
        .vueperslides__parallax-wrapper {
            height:inherit;
            padding-bottom:0 !important;
        }
    }
    .gallery {
        .vueperslides__inner {
            height:inherit;
        }
        .vueperslides__parallax-wrapper {
            height:inherit;
            padding-bottom:0 !important;
        }
    }
    .vueperslides__arrows {
        position:absolute;
        bottom:20px;
        width:100%;
        height:30px;
        box-sizing: border-box;
        button {
            margin:0;
            padding:0;            
            .icon {
                background: rgba(#0B0B0B, 0.7);
            }
            &.vueperslides__arrow--prev {
                left:20px;
            }
            &.vueperslides__arrow--next {
                right:20px;
            }
        }
    }

</style>
<style lang="scss" scoped>
.fullscreen-images {
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index: 4;
}
.page.content {
    padding:0;    
}
svg {
    flex-grow: 1;
    background:url('~@/assets/images/event_production/BACKSTAGE-MAP-IMAGE.jpg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width:100%;
    height:100%;
    object-fit: contain;
    object-position: center;
}
.gallery {
    height:155px;
    width:100%;
    position: absolute;
    left:0;
    top:0;
    transform:translateY(-100%);
    .images {
        height:100%;
        width:100%;
    }
}
.location {
    cursor: pointer;    
}
.feature-list {
    position: absolute;
    width: 290px;
    border-radius: 3px;
    background: linear-gradient(180deg, rgba(#FFFFFF, 0.9) 0%, rgba(#D8D8D8, 0.9) 100%);    
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.30);
    .name {
        font-family: 'Gotham';
        font-size: 1em;
        font-weight: 900;
        letter-spacing: 0;
        line-height: 1;
        border-radius: 3px 3px 0 0;
        background: linear-gradient(135deg, #232323 0%, #0C0C0C 100%);
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.2);
        padding:20px 24px;
        margin:0;
    }
    .feature {
        color: #2E2E30;
        font-family: 'Gotham';
        font-size: 0.8em;
        font-weight: 300;
        letter-spacing: 0;
        line-height: 20px;
        padding:13px 24px;
        margin:0;
        &:not(:last-child) {
            border-bottom:1px solid #B2B3B8;
        }
    }
}
.page {
    padding:85px 50px;
    padding-right:0;
    position: relative;
    display: flex;
    flex-direction: column;
    background:#000;
    box-sizing: border-box;
}
.note {
    color: #B2B3B8;
    font-family: Montserrat;
    font-size: 0.8em;
    letter-spacing: 0;
    line-height: 1;
    padding-left:50px;
    padding-bottom: 85px;
}
</style>
